import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import TextButton from 'LuxKit/Button/TextButton'
import ModalContext from 'contexts/ModalContext'
import type { MouseEventHandler } from 'react'
import React, { useCallback, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  isLoginForMemberSavings?: boolean
}

function BedbankSearchTileSignUpButton({ isLoginForMemberSavings }: Props) {
  const intl = useIntl()
  const showModal = useContext(ModalContext)
  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    showModal(<AccountAccessModal />)
  }, [showModal])

  const signUpAndSaveMoreText = useMemo(() => intl.formatMessage({
    id: 'XceuT9G+SY',
    defaultMessage: 'Sign up & save more',
    description: 'Sign up button text for member savings on bedbank search tiles',
  }), [intl])

  const signUpForFreeText = useMemo(() => intl.formatMessage({
    id: 'TcX3QGY3aV',
    defaultMessage: 'Sign up for free',
    description: 'Sign up button text on bedbank search tiles in the search interface',
  }), [intl])

  if (isLoginForMemberSavings) {
    return <TextButton kind="primary" nonInteractable onClick={handleClick}>
      {signUpAndSaveMoreText}
    </TextButton>
  }

  return <TextButton kind="secondary" nonInteractable onClick={handleClick}>
    {signUpForFreeText}
  </TextButton>
}

export default BedbankSearchTileSignUpButton
